<template>
  <el-dialog width="420px" title="" class="dialogClass" :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="accountVisible">
    <div class="details">
      <div class="dialogTilte">改绑{{is_account}}</div>
      <div class="mb-16">
        <el-steps :active="activeStep" align-center>
          <el-step title="安全认证" description=""></el-step>
          <el-step :title="'改绑'+is_account" description=""></el-step>
          <el-step title="完成" description=""></el-step>
        </el-steps>
      </div>
      <el-form    ref="currencyForm"   v-loading="loading"    label-position="right"   label-width="110px"  :model="currencyForm"  :rules="currencyFormRules">
        <template v-if="activeStep == 1">
          <el-form-item prop="account" label="账号">
            <el-input type="text" v-model="currencyForm.account" disabled auto-complete="new-password" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item prop="code" label="验证码">
            <el-input maxlength="6" placeholder="请输入验证码" v-model="currencyForm.code"  auto-complete="new-password">
              <el-button :disabled="getCodeBtnDisabled"  @click="handleClickGetEmailCode('change_account_verify')"
                         slot="suffix"
                         type="text">
                {{getCodeText}}
              </el-button>
            </el-input>
          </el-form-item>
        </template>

        <template v-if="activeStep == 2">
          <el-form-item prop="new_account" :label="'绑定新'+is_account">
            <el-input v-model="currencyForm.new_account"  :placeholder="'请输入'+is_account" ></el-input>
          </el-form-item>
            <el-form-item prop="new_code" label="验证码">
            <el-input maxlength="6" placeholder="请输入验证码" v-model="currencyForm.new_code"  >
              <el-button :disabled="getCodeBtnDisabled2"  @click="handleClickGetEmailCode('change_account')"
                         slot="suffix"
                         type="text">
                {{getCodeText2}}
              </el-button>
            </el-input>
          </el-form-item>
        </template>

        <template v-if="activeStep == 3">
          <div class="tips">绑定{{is_account}}修改成功，将在{{time}}s后退出登录</div>
        </template>


      </el-form>
    </div>
    <div slot="footer">
      <el-button  v-if="activeStep == 1" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button type="primary" v-if="activeStep == 1" :disabled="BtnDisabled" @click="handleClickNext">下一步</el-button>
      <el-button type="primary" v-if="activeStep == 2" :disabled="BtnDisabled" @click="handleClickPrev">上一步</el-button>
      <el-button type="primary" v-if="activeStep == 2" :disabled="BtnDisabled" @click="handleClickConfirm">确认修改</el-button>
      <el-button type="primary" v-if="activeStep == 3" :disabled="BtnDisabled" @click="handleClickLogout">立即登出</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { sendMailCode,sendPhoneCode,changeAccoutVerfiy ,changeAccout } from '@/api/api'
import {mapState} from "vuex";

export default {
  name: 'change_account',
  props: {
    accountVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      activeStep:1,
      currencyForm:{
        account: '',
        code:'',
        new_account: '',
        new_code:'',
      },
      currencyFormRules:{
        code:[{ required: true, message: '请输入验证码', trigger: 'blur'}],
        new_account:[{ required: true, message: `请输入`, trigger: 'blur'}],
        new_code:[{ required: true, message: '请输入验证码', trigger: 'blur'}],
      },
      getCodeTime: 60,
      getCodeTime2: 60,
      getCodeBtnDisabled: false,
      getCodeBtnDisabled2: false,
      time:5,
      is_account:''

    }
  },

  created() {

  },
  computed: {
    ...mapState(['webUserInfo']),
    getCodeText() {
      if (this.getCodeBtnDisabled) {
        return `${this.getCodeTime}秒后重新发送`;
      } else {
        return '获取验证码';
      }
    },
    getCodeText2() {
      if (this.getCodeBtnDisabled2) {
        return `${this.getCodeTime2}秒后重新发送`;
      } else {
        return '获取验证码';
      }
    },
  },
  mounted() {
    this.currencyForm.account = this.webUserInfo.email ? this.webUserInfo.email :this.webUserInfo.phone
    this.is_account = this.webUserInfo.email ? '邮箱' : '手机'
  },
  methods: {
    // 获取验证码
    handleClickGetEmailCode(sendType){
        let account = sendType == 'change_account_verify' ? this.currencyForm.account : this.currencyForm.new_account
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const phonePattern = /^1[3456789]\d{9}$/;
        if(emailPattern.test(account)){
          sendMailCode({
            email: account,
            type : sendType
          }).then(res => {
            if (res.code === 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'success',
                duration: 1500,
                onClose: () => { }
              });
              this.codeBtnDisabled(sendType)

            }
          })
        }else if(phonePattern.test(account)){
          sendPhoneCode({
            phone: account,
            type : sendType
          }).then(res => {
            if (res.code === 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'success',
                duration: 1500,
                onClose: () => { }
              });
               this.codeBtnDisabled(sendType)
            }
          })
        }else{
           this.$message({
             showClose: true,
             message: `请输入正确的${this.is_account}`,
             type: 'error',
             duration: 1500,
             onClose: () => { }
           });
        }


    },
    codeBtnDisabled(sendType){
      if(sendType == 'change_account_verify'){
         this.getCodeBtnDisabled = true;
         const timer = setInterval(() => {
           if (this.getCodeTime > 0) {
             this.getCodeTime--;
           } else {
             this.getCodeBtnDisabled = false;
             clearInterval(timer);
             this.getCodeTime = 60;
           }
         }, 1000);
       }else{
         this.getCodeBtnDisabled2 = true;
         const timer = setInterval(() => {
           if (this.getCodeTime2 > 0) {
             this.getCodeTime2--;
           } else {
             this.getCodeBtnDisabled2 = false;
             clearInterval(timer);
             this.getCodeTime2 = 60;
           }
         }, 1000);
       }
    },


    // 下一步
    handleClickNext(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          changeAccoutVerfiy({
            account:this.currencyForm.account,
            code:this.currencyForm.code,
          }).then(res => {
            if (res.code === 200) {
              this.activeStep = 2
            }else {
                this.$message({
                showClose: true,
                message: res.message,
                type: 'error',
                duration: 1500,
                onClose: () => { }
              });
            }
          })


        }
     })
    },
    // 上一步
    handleClickPrev(){
      this.activeStep = 1
    },
    // 登出
    handleClickLogout(){
      this.$store.dispatch('clearWebUserInfo')
      this.$router.replace({name:'login'});
    },
    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          changeAccout({
            account:this.currencyForm.new_account,
            code:this.currencyForm.new_code,
          }).then(res => {
            if (res.code === 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'success',
                duration: 1500,
                onClose: () => { }
              });
              this.activeStep = 3
              setInterval(()=>{
                this.time--
                if(this.time == 0){
                  this.$store.dispatch('clearWebUserInfo')
                  this.$router.replace({name:'login'});
                }
              },1000)
            }
          })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:accountVisible', false)
      if( this.activeStep == 3){
        this.$store.dispatch('clearWebUserInfo')
        this.$router.replace({name:'login'});
      }
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.tips{
  line-height: 84px;
  margin-bottom: 18px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}

</style>
